import { Mention as TipTapMention } from 'tiptap-extensions'

export default class Mention extends TipTapMention {
  get name() {
    return 'mention'
  }

  getLabel(dom) {
    return dom.innerText.split(this.options.matcher.char).join('')
  }

  get schema() {
    return {
      ...super.schema,
      attrs: {
        id: {},
        uid: {},
        label: {},
        email: {},
      },
      toDOM: node => [
        'span',
        {
          class: this.options.mentionClass,
          id: node.attrs.uid,
          'data-mention-id': node.attrs.id,
          'data-mention-label': node.attrs.label,
          'data-mention-email': node.attrs.email,
        },
        `${this.options.matcher.char}${node.attrs.label}`,
      ],
      parseDOM: [
        {
          tag: 'span[data-mention-id]',
          getAttrs: dom => {
            const id = dom.getAttribute('data-mention-id')
            const uid = dom.getAttribute('id')
            const label = this.getLabel(dom)
            const email = dom.getAttribute('data-mention-email')
            return { id, uid, label, email }
          },
          getContent: (dom, schema) => {
            const label = this.getLabel(dom)
            return this.createFragment(schema, label)
          },
        },
      ],
    }
  }
}
